/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} A11y_Statement_Limitations_ExtensionInputs */

const en_a11y_statement_limitations_extension = /** @type {(inputs: A11y_Statement_Limitations_ExtensionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chrome extension not yet fully accessibility-tested`)
};

const de_a11y_statement_limitations_extension = /** @type {(inputs: A11y_Statement_Limitations_ExtensionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Chrome-Erweiterung wurde noch nicht vollständig auf Barrierefreiheit geprüft`)
};

const fr_a11y_statement_limitations_extension = /** @type {(inputs: A11y_Statement_Limitations_ExtensionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'extension Chrome n'a pas encore ete entierement testee en matiere d'accessibilite`)
};

const es_a11y_statement_limitations_extension = /** @type {(inputs: A11y_Statement_Limitations_ExtensionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La extension de Chrome aun no ha sido completamente probada en accesibilidad`)
};

const it_a11y_statement_limitations_extension = /** @type {(inputs: A11y_Statement_Limitations_ExtensionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'estensione Chrome non e ancora stata completamente testata per l'accessibilita`)
};

const nl_a11y_statement_limitations_extension = /** @type {(inputs: A11y_Statement_Limitations_ExtensionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chrome-extensie is nog niet volledig getest op toegankelijkheid`)
};

const pl_a11y_statement_limitations_extension = /** @type {(inputs: A11y_Statement_Limitations_ExtensionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozszerzenie Chrome nie zostalo jeszcze w pelni przetestowane pod katem dostepnosci`)
};

const fi_a11y_statement_limitations_extension = /** @type {(inputs: A11y_Statement_Limitations_ExtensionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chrome-laajennusta ei ole vielä täysin testattu saavutettavuuden osalta`)
};

const da_a11y_statement_limitations_extension = /** @type {(inputs: A11y_Statement_Limitations_ExtensionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chrome-udvidelsen er endnu ikke fuldt tilgaengelighedstestet`)
};

const sv_a11y_statement_limitations_extension = /** @type {(inputs: A11y_Statement_Limitations_ExtensionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chrome-tillgget har annu inte fullt ut testats for tillganglighet`)
};

/**
* | output |
* | --- |
* | "Chrome extension not yet fully accessibility-tested" |
*
* @param {A11y_Statement_Limitations_ExtensionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const a11y_statement_limitations_extension = /** @type {((inputs?: A11y_Statement_Limitations_ExtensionInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<A11y_Statement_Limitations_ExtensionInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_a11y_statement_limitations_extension(inputs)
	if (locale === "fr") return fr_a11y_statement_limitations_extension(inputs)
	if (locale === "es") return es_a11y_statement_limitations_extension(inputs)
	if (locale === "it") return it_a11y_statement_limitations_extension(inputs)
	if (locale === "nl") return nl_a11y_statement_limitations_extension(inputs)
	if (locale === "pl") return pl_a11y_statement_limitations_extension(inputs)
	if (locale === "fi") return fi_a11y_statement_limitations_extension(inputs)
	if (locale === "da") return da_a11y_statement_limitations_extension(inputs)
	if (locale === "sv") return sv_a11y_statement_limitations_extension(inputs)
	return en_a11y_statement_limitations_extension(inputs)
});